export default __webpack_public_path__ + "static/SRF 3360PW - Fiche de spécifications et données techniques-636047734362c296a55f2d246f80f031.pdf";